export default function env(name, defaultValue = '') {
    return (
        (window.__env__ && window.__env__[name]) ||
        process.env[name] ||
        defaultValue
    )
}
